import { FC } from 'react'
import { Card, Text, Link, Accordion, CardColors } from '@/ui'
import { TypographyStyles } from '@/styles'

export const QTEFAQs: FC = () => {
  return (
    <Card color={CardColors.LEVEL_0}>
      <Accordion type="multiple" collapsible className="w-full inline-block">
        <Accordion.Item value="0" className="border-none">
          <Accordion.Trigger className="p-0">
            <Text
              className="flex items-center justify-between w-full"
              variant={TypographyStyles.H2}
            >
              Common FAQs
            </Text>
          </Accordion.Trigger>

          <Accordion.Content className="mt-2">
            <div className="space-y-4">
              <Link
                href="https://support.joinheard.com/hc/en-us/articles/4416208037655-What-are-quarterly-tax-estimates-"
                newPage
              >
                What are Quarterly Tax Estimates?
              </Link>
              <Link
                href="https://support.joinheard.com/hc/en-us/articles/4416208116247-How-does-Heard-calculate-my-quarterly-estimated-taxes-"
                newPage
              >
                How are my estimates calculated?
              </Link>
              <Link
                href="https://support.joinheard.com/hc/en-us/articles/4416196188439-What-do-you-mean-by-estimate-Can-I-pay-more-or-less-than-the-estimate-you-gave-me-"
                newPage
              >
                Can I pay more or less than the amount you gave me?
              </Link>
              <Link
                href="https://support.joinheard.com/hc/en-us/articles/4416196562967-What-if-I-didn-t-pay-my-quarterly-estimates-for-prior-quarters-this-year-"
                newPage
              >
                What if I missed one or more quarterly tax payments this year?
              </Link>
              <Link
                href="https://support.joinheard.com/hc/en-us/articles/4416233114647-Should-I-pay-quarterly-taxes-from-my-personal-or-business-bank-account-"
                newPage
              >
                Do I pay taxes out of my personal or business bank account?
              </Link>
              <Link
                href="https://support.joinheard.com/hc/en-us/sections/4416200689303-Quarterly-Taxes"
                newPage
                variant="secondary"
                className="text-moss-500"
              >
                View all FAQs
              </Link>
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion>
    </Card>
  )
}
